<script setup lang="ts">
import { Sign as SignInterface } from '@/models/sign'
import { $getSignTemplateTypes } from '@/api/settings'
import ability from '@/plugins/casl/ability'

interface IProps {
  sign?: SignInterface,
}

const props = withDefaults(defineProps<IProps>(), {
  sign: () => ({}),
})

interface Emit {
  (e: 'update:sign', value: SignInterface): void
}

const emit = defineEmits<Emit>()

const isUserCanChangeInput = computed(() => {
  return ability.can('change', 'sign') && props.sign.is_active_campaign
})

const signTemplateTypes = ref<any[]>([])
const loading = ref<boolean>(false)

const getSignTemplateTypes = async () => {
  loading.value = true
  const filters = {
    per_page: -1,
    catalogue: props?.sign?.campaign_sign_template_type_catalogue_id || undefined
  }

  try {
    const res = await $getSignTemplateTypes(filters)
    signTemplateTypes.value = res.data.results
  } catch (e) {
    console.log(e)
  } finally {
    loading.value = false
  }
}

watch(() => props.sign, () => {
  getSignTemplateTypes()
})
</script>

<template>
  <!-- Show/hide Template Type Field based on Project Template Type Catalogue -->
  <VCol
    v-if="props?.sign?.campaign_sign_template_type_catalogue_id"
    cols="12"
  >
    <VSelect
      v-model="sign.template_type"
      :items="signTemplateTypes"
      :disabled="!isUserCanChangeInput"
      :loading="!!loading"
      clearable
      item-title="name"
      item-value="id"
      label="Sign Template Type"
    />
  </VCol>
</template>

<style lang="scss">
.reject-previous-statuses-menu-block {
  box-shadow: 0 3px 17px -10px #5e5e5e !important;
}
</style>
